import { render, staticRenderFns } from "./MaintenancesTab.vue?vue&type=template&id=3b465db9"
import script from "./MaintenancesTab.vue?vue&type=script&lang=js"
export * from "./MaintenancesTab.vue?vue&type=script&lang=js"
import style0 from "./MaintenancesTab.vue?vue&type=style&index=0&id=3b465db9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports